import React, { useState } from 'react';
import Button from "@amzn/awsui-components-core/button";
import Tabs from "@amzn/awsui-components-core/tabs";
import { useUser } from 'src/context/UserContext';
import { greenButtonStyles, TabsStyles } from 'src/components/shared/design-tokens';
import { getReadablePassdownTabs } from 'src/roles-permissions';
import GlobalPassdown from './GlobalPassdown';
import CSPassdown from './CSPassdown';
import CSIRPassdown from './CSIRPassdown';
import CMPassdown from './CMPassdown';
import OIMPassdown from './OIMPassdown';
import AlarmsPassdown from './AlarmsPassdown';
import EventsPassdown from './EventsPassdown';
import './Passdown.scss';

const Passdown = () => {
    const { user, canWrite } = useUser();
    const readableTabs = getReadablePassdownTabs(user?.permissions || []);
    // const readableTabs = ['global', 'alarms', 'cm', 'cs', 'csir', 'events', 'oim'];
    const canReadGlobal = readableTabs.includes('global');
    const canReadCS = readableTabs.includes('cs');
    const canReadCSIR = readableTabs.includes('csir');
    const canReadCM = readableTabs.includes('cm');
    const canReadAlarms = readableTabs.includes('alarms');
    const canReadEvents = readableTabs.includes('events');
    const canReadOIM = readableTabs.includes('oim');
    const [activeTab, setActiveTab] = useState(
        canReadGlobal ? 'global' :
        canReadAlarms ? 'alarms' :
        canReadCM ? 'cm' :
        canReadCS ? 'cs' :
        canReadCSIR ? 'csir' :
        canReadEvents ? 'events' :
        canReadOIM ? 'oim' : 'global'
    );
    const [showForm, setShowForm] = useState(false);

    const WRITE_PERMISSIONS: Record<string, keyof import('src/services/api').SectionPermissions> = {
        global: 'globalShiftPassdown',
        alarms: 'alarmsShiftPassdown',
        cm: 'cmShiftPassdown',
        cs: 'csShiftPassdown',
        csir: 'csirShiftPassdown',
        events: 'eventsShiftPassdown',
        oim: 'oimShiftPassdown',
    };
    const canEdit = canWrite(WRITE_PERMISSIONS[activeTab] || 'globalShiftPassdown');

    const TAB_LABELS: Record<string, string> = {
        global: 'New Global Passdown',
        alarms: 'New Alarms Passdown',
        cm: 'New CM Passdown',
        cs: 'New CS Passdown',
        csir: 'New CSIR Passdown',
        events: 'New Events Passdown',
        oim: 'New OIM Passdown',
    };
    const newPassdownLabel = TAB_LABELS[activeTab] || 'New Passdown';

    const handleTabChange = (tabId: string) => {
        if (!tabId || tabId === activeTab) return;
        setActiveTab(tabId);
        setShowForm(false); // close any open form when switching tabs
    };

    return (
        <div className="shift-passdown">
            <div className="section-card">
                <div className="section-card__header section-card__no-header-border">
                    <h3 className="section-card__title">Passdowns</h3>
                     {canEdit && !showForm && (
                        <Button
                            variant="primary"
                            style={greenButtonStyles}
                            onClick={() => setShowForm(true)}
                        >
                            {newPassdownLabel}
                        </Button>
                    )}
                </div>

                <div className="shift-passdown__tabs-row">
                    <Tabs
                        activeTabId={activeTab}
                        style={TabsStyles}
                        fitHeight
                        onChange={({ detail }) => handleTabChange(detail.activeTabId)}
                        tabs={[
                            ...(canReadGlobal ? [{
                                label: "Global",
                                id: "global",
                                content: <GlobalPassdown showForm={showForm} setShowForm={setShowForm} />
                            }] : []),
                            ...(canReadAlarms ? [{
                                label: "Alarms",
                                id: "alarms",
                                content: <AlarmsPassdown showForm={showForm} setShowForm={setShowForm} />
                            }] : []),
                            ...(canReadCM ? [{
                                label: "CM",
                                id: "cm",
                                content: <CMPassdown showForm={showForm} setShowForm={setShowForm} />
                            }] : []),
                            ...(canReadCS ? [{
                                label: "CS",
                                id: "cs",
                                content: <CSPassdown showForm={showForm} setShowForm={setShowForm} />
                            }] : []),
                            ...(canReadCSIR ? [{
                                label: "CSIR",
                                id: "csir",
                                content: <CSIRPassdown showForm={showForm} setShowForm={setShowForm} />
                            }] : []),
                            ...(canReadEvents ? [{
                                label: "Events",
                                id: "events",
                                content: <EventsPassdown showForm={showForm} setShowForm={setShowForm} />
                            }] : []),
                            ...(canReadOIM ? [{
                                label: "OIM",
                                id: "oim",
                                content: <OIMPassdown showForm={showForm} setShowForm={setShowForm} />
                            }] : []),
                        ]}
                        variant='container'
                    />
                </div>


            </div>
        </div>
    );
};

export default Passdown;
